export class AreaProjects {
    getProjects(workspaceId) {
        return this.dataCore.getForgeProjects(workspaceId);
    }
    updateProject(workspaceId, projectId, data) {
        return this.dataCore.updateForgeProject(workspaceId, projectId, data);
    }
    deleteProject(workspaceId, projectId) {
        return this.dataCore.deleteForgeProject(workspaceId, projectId);
    }
    createProject(workspaceId, data) {
        return this.dataCore.createForgeProject(workspaceId, data);
    }
    getProjectMemberships(workspaceId, projectId) {
        return this.dataCore.getForgeProjectMemberships(workspaceId, projectId);
    }
    createProjectMember(workspaceId, projectId, data) {
        return this.dataCore.createForgeProjectMember(workspaceId, projectId, data);
    }
    updateProjectMember(workspaceId, projectId, data) {
        return this.dataCore.updateForgeProjectMember(workspaceId, projectId, data);
    }
    removeProjectMember(workspaceId, projectId, data) {
        return this.dataCore.removeForgeProjectMember(workspaceId, projectId, data);
    }
    getProjectFeature(workspaceId, projectId, featureId) {
        return this.dataCore.getForgeProjectFeature(workspaceId, projectId, featureId);
    }
    getProjectFeatures(workspaceId, projectId) {
        return this.dataCore.getForgeProjectFeatures(workspaceId, projectId);
    }
    projectAction(workspaceId, projectId, data) {
        return this.dataCore.projectAction(workspaceId, projectId, data);
    }
    createProjectFeature(workspaceId, projectId, data, tId) {
        return this.dataCore.createForgeProjectFeature(workspaceId, projectId, data, tId);
    }
    updateProjectFeature(workspaceId, projectId, data, tId) {
        return this.dataCore.updateForgeProjectFeature(workspaceId, projectId, data, tId);
    }
    deleteProjectFeature(workspaceId, projectId, data, tId) {
        return this.dataCore.deleteForgeProjectFeature(workspaceId, projectId, data, tId);
    }
    moveProjectFeature(workspaceId, projectId, data, tId) {
        return this.dataCore.moveForgeProjectFeature(workspaceId, projectId, data, tId);
    }
    createProjectDocument(workspaceId, projectId, data, tId) {
        return this.dataCore.createForgeProjectDocument(workspaceId, projectId, data, tId);
    }
    updateProjectDocument(workspaceId, projectId, data, tId) {
        return this.dataCore.updateForgeProjectDocument(workspaceId, projectId, data, tId);
    }
    deleteProjectDocument(workspaceId, projectId, data, tId) {
        return this.dataCore.deleteForgeProjectDocument(workspaceId, projectId, data, tId);
    }
    moveProjectDocument(workspaceId, projectId, data, tId) {
        return this.dataCore.moveForgeProjectDocument(workspaceId, projectId, data, tId);
    }
    getProjectDocument(workspaceId, projectId, documentId) {
        return this.dataCore.getForgeProjectDocument(workspaceId, projectId, documentId);
    }
    getProjectDocumentContent(workspaceId, projectId, documentId) {
        return this.dataCore.getForgeProjectDocumentContent(workspaceId, projectId, documentId);
    }
    getProjectDocuments(workspaceId, projectId) {
        return this.dataCore.getForgeProjectDocuments(workspaceId, projectId);
    }
    createProjectSection(workspaceId, projectId, data, tId) {
        return this.dataCore.createForgeProjectSection(workspaceId, projectId, data, tId);
    }
    updateProjectSection(workspaceId, projectId, data, tId) {
        return this.dataCore.updateForgeProjectSection(workspaceId, projectId, data, tId);
    }
    deleteProjectSection(workspaceId, projectId, data, tId) {
        return this.dataCore.deleteForgeProjectSection(workspaceId, projectId, data, tId);
    }
    moveProjectSection(workspaceId, projectId, data, tId) {
        return this.dataCore.moveForgeProjectSection(workspaceId, projectId, data, tId);
    }
    async getProjectRoom(workspaceId, projectId) {
        return this.dataCore.getForgeProjectRoom(workspaceId, projectId);
    }
    async getProjectDocumentRoom(workspaceId, projectId, artifactId) {
        return this.dataCore.getForgeProjectDocumentRoom(workspaceId, projectId, artifactId);
    }
    async getProjectFeatureRoom(workspaceId, projectId, featureId) {
        return this.dataCore.getForgeProjectFeatureRoom(workspaceId, projectId, featureId);
    }
    /* @deprecated use AreaThreads instead */
    async getProjectFeatureMessages(workspaceId, projectId, featureId) {
        return this.dataCore.getForgeProjectFeatureMessages(workspaceId, projectId, featureId);
    }
    /* @deprecated use AreaThreads instead */
    async createProjectFeatureMessage(workspaceId, projectId, featureId, input) {
        return this.dataCore.createForgeProjectFeatureMessage(workspaceId, projectId, featureId, input);
    }
    /* @deprecated use AreaThreads instead */
    async createProjectFeatureMessageReaction(workspaceId, projectId, featureId, input) {
        return this.dataCore.createForgeProjectFeatureMessageReaction(workspaceId, projectId, featureId, input);
    }
    /* @deprecated use AreaThreads instead */
    async removeProjectFeatureMessageReaction(workspaceId, projectId, featureId, input) {
        return this.dataCore.removeForgeProjectFeatureMessageReaction(workspaceId, projectId, featureId, input);
    }
    async getProjectFeatureArtifacts(workspaceId, projectId, featureId) {
        return this.dataCore.getForgeProjectFeatureArtifacts(workspaceId, projectId, featureId);
    }
    async createProjectFeatureArtifact(workspaceId, projectId, featureId, input) {
        return this.dataCore.createForgeProjectFeatureArtifact(workspaceId, projectId, featureId, input);
    }
    async deleteProjectFeatureArtifact(workspaceId, projectId, featureId, input) {
        return this.dataCore.deleteForgeProjectFeatureArtifact(workspaceId, projectId, featureId, input);
    }
    async getProjectFeatureIterations(workspaceId, projectId, featureId) {
        return this.dataCore.getForgeProjectFeatureIterations(workspaceId, projectId, featureId);
    }
    async createProjectFeatureIteration(workspaceId, projectId, featureId, input) {
        return this.dataCore.createForgeProjectFeatureIteration(workspaceId, projectId, featureId, input);
    }
    async updateProjectFeatureIteration(workspaceId, projectId, featureId, input) {
        return this.dataCore.updateForgeProjectFeatureIteration(workspaceId, projectId, featureId, input);
    }
    async updateProjectFeatureIterationArtifacts(workspaceId, projectId, featureId, input) {
        // Check if this is a message-based update
        if ("messageId" in input) {
            return this.dataCore.updateProjectFeatureIterationByMessageArtifacts(workspaceId, projectId, featureId, input);
        }
        // Otherwise it's an iteration-based update
        return this.dataCore.updateForgeProjectFeatureIterationArtifacts(workspaceId, projectId, featureId, input);
    }
    async finalizeProjectFeatureAgentWork(workspaceId, projectId, featureId, input) {
        return this.dataCore.finalizeForgeProjectFeatureAgentWork(workspaceId, projectId, featureId, input);
    }
    async promoteProjectFeatureIteration(workspaceId, projectId, featureId, input) {
        return this.dataCore.promoteForgeProjectFeatureIteration(workspaceId, projectId, featureId, input);
    }
    async setLatestProjectFeatureIteration(workspaceId, projectId, featureId, input) {
        return this.dataCore.setLatestForgeProjectFeatureIteration(workspaceId, projectId, featureId, input);
    }
    async updateProjectFeatureTheme(workspaceId, projectId, featureId, input) {
        return this.dataCore.updateForgeProjectFeatureTheme(workspaceId, projectId, featureId, input);
    }
    getProjectContexts(workspaceId) {
        return this.dataCore.getForgeProjectContexts({ workspaceId });
    }
    async createProjectContext(input) {
        return this.dataCore.createForgeProjectContext(input);
    }
    async getProjectContext(id) {
        return this.dataCore.getForgeProjectContext(id);
    }
    async updateProjectContext(id, input) {
        return this.dataCore.updateForgeProjectContext(id, input);
    }
    async deleteProjectContext(id) {
        return this.dataCore.deleteForgeProjectContext(id);
    }
    async updateProjectContextOverride(wsId, projectId, data, options = {}) {
        return this.dataCore.updateForgeProjectContextOverride(wsId, projectId, data, options);
    }
    async getProjectTrailEvents(projectId) {
        return this.dataCore.getProjectTrailEvents(projectId);
    }
    constructor(dataCore) {
        this.dataCore = dataCore;
    }
}
